import { render, staticRenderFns } from "./SettingTrainOfPersonal.vue?vue&type=template&id=2f6684eb&scoped=true"
import script from "./SettingTrainOfPersonal.vue?vue&type=script&lang=js"
export * from "./SettingTrainOfPersonal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6684eb",
  null
  
)

export default component.exports